import { Country } from '@afterpay/types'
import { useConsumerCountry } from '../../state'
import { LaunchDarklyFlags, useFlag } from '../useFlag'

export interface UkRegFlags {
  isGbRegFlow: boolean
  isUkRegsAffordabilityFormEnabled: boolean
  isUkMarketRegsFCA: boolean
  // Flag-only values without country gating. Used by hooks where the country
  // comes from an async response or function parameter rather than Redux,
  // so the consumer applies its own inline country check.
  // - isUkRegsServicingFlagEnabled: used by registration/profile flows with a country parameter.
  // - isUkRegsAffordabilityFormFlagEnabled: used by useLoggedInRedirect with async fetchAccount.
  isUkRegsServicingFlagEnabled: boolean
  isUkRegsAffordabilityFormFlagEnabled: boolean
}

export const useUkRegFlags = (): UkRegFlags => {
  const country = useConsumerCountry()
  const isGbCountry = country === Country.GB

  const ukRegsServicingFlag = useFlag(LaunchDarklyFlags.EnableUkRegsServicing)
  const ukRegsAffordabilityFormFlag = useFlag(LaunchDarklyFlags.EnableUkRegsAffordabilityForm)
  const ukMarketRegsFCAFlag = useFlag(LaunchDarklyFlags.UK_MRKT_REGS_FCA)

  const isGbRegFlow = ukRegsServicingFlag && isGbCountry
  const isUkRegsAffordabilityFormEnabled = ukRegsAffordabilityFormFlag && isGbCountry

  return {
    isGbRegFlow,
    isUkRegsAffordabilityFormEnabled,
    isUkMarketRegsFCA: ukMarketRegsFCAFlag && isGbCountry,
    isUkRegsServicingFlagEnabled: ukRegsServicingFlag,
    isUkRegsAffordabilityFormFlagEnabled: ukRegsAffordabilityFormFlag,
  }
}
